import * as types from '../actions/actionTypes';
import { newMapWith, replaceInMap } from './common';
import { isUndefinedNullOrEmpty } from '../utils';
import { updateStatuses, asyncronousOperationStatuses } from '../statuses';
import initialState from './initialState';

const mapUpdateStatusToAsyncOperationStatus = (updateStatus) => {
    switch(updateStatus) {
        case updateStatuses.initial:
            return asyncronousOperationStatuses.initial;

        case updateStatuses.requested:
            return asyncronousOperationStatuses.requested;

        case updateStatuses.success:
            return asyncronousOperationStatuses.requestAccepted;

        case updateStatuses.failure:
            return asyncronousOperationStatuses.requestRejected;
    }
};

const instanceDetailsReducer = (state = initialState.instanceDetails, action) => {
    switch(action.type) {
        case types.DATABASES_ON_INSTANCE_UPDATED: {
            const { sqlServerInstanceId, updateStatus } = action;
            const existingDetails = state.get(sqlServerInstanceId);
            const asyncOpStatus = mapUpdateStatusToAsyncOperationStatus(updateStatus);

            if(!isUndefinedNullOrEmpty(existingDetails)) {
                const updatedDetails = { 
                    ...existingDetails, 
                    updateStatus: asyncOpStatus
                };

                return replaceInMap(state, sqlServerInstanceId, updatedDetails);

            } else {
                const instanceDetails = { 
                    updateStatus: asyncOpStatus
                };

                return newMapWith(state, sqlServerInstanceId, instanceDetails);
            }
        }

        case types.INSTANCE_DETAILS_UPDATED: {
            const { instanceId, databases } = action.value;
            const asyncOpStatus = action.value.isSuccess ? asyncronousOperationStatuses.success : asyncronousOperationStatuses.failure;
            const existingDetails = state.get(instanceId);

            if(!isUndefinedNullOrEmpty(existingDetails)) {
                const updatedDetails = { 
                    ...existingDetails, 
                    updateStatus: asyncOpStatus,
                    databaseNames: databases 
                };

                return replaceInMap(state, instanceId, updatedDetails);

            } else {
                const instanceDetails = { 
                    updateStatus: asyncOpStatus,
                    databaseNames: databases 
                };

                return newMapWith(state, instanceId, instanceDetails);
            }
        }

        default:
            return state;
    }
};

export default instanceDetailsReducer;


// WEBPACK FOOTER //
// ./src/js/reducers/instanceDetailsReducer.js